import { atom } from "../../../app-jotai";

export const kmdDialogAtom = atom<{ open: boolean; initialText?: string }>({
  open: false,
});

export const agentTemplateDialogAtom = atom<{ open: boolean }>({
  open: false,
});
